'use client'

import * as React from 'react'
import { motion } from 'motion/react'

import cn from '@config/tailwind/cn'

import type { BookCoverCardSize } from './book-cover-card'
import type { CardAction } from './card-action'
import { bookCoverCardSizeStyles } from './book-cover-card'

interface ContinueReadingCardProps {
  id: string
  title: string
  coverUrl: string
  progress: number
  action: CardAction
  size?: BookCoverCardSize
  className?: string
}

export function ContinueReadingCard({
  id,
  title,
  coverUrl,
  progress,
  action,
  size = 'large',
  className,
}: ContinueReadingCardProps) {
  const clampedProgress = Math.min(100, Math.max(0, progress))
  const { img } = bookCoverCardSizeStyles[size]

  const content = (
    <motion.div
      data-id={id}
      whileHover={{ scale: 1.025 }}
      whileTap={{ scale: 0.975 }}
      className={cn('srd:flex srd:flex-col srd:cursor-pointer', className)}
      style={{ width: img.width }}
    >
      <div
        className='srd:w-full srd:rounded-2xl srd:overflow-hidden srd:bg-grey-10 srd:relative'
        style={{ height: img.height }}
      >
        <img
          src={coverUrl}
          alt={title}
          width={img.width}
          height={img.height}
          draggable={false}
          loading='lazy'
          decoding='async'
          className='srd:w-full srd:h-full srd:object-cover'
        />
        <div
          className={cn(
            'srd:absolute srd:rounded-full srd:overflow-hidden srd:bg-grey-100/50 srd:bottom-0 srd:left-0 srd:w-full srd:h-2',
          )}
        >
          <motion.div
            className='srd:h-full srd:rounded-full srd:bg-[#E73957]'
            initial={{ width: '0%' }}
            animate={{ width: `${clampedProgress}%` }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          />
        </div>
      </div>
    </motion.div>
  )

  if (action.type === 'link') return action.renderWrapper(content)

  return (
    <button type='button' onClick={action.onClick} className='srd:w-full srd:text-left'>
      {content}
    </button>
  )
}
